import { shouldValidateFormForUser } from '../helpers/formHelper'

function saveUser({ state, output, services }) {
  let current = state.get('client.registrating.current')
  let currentUser = state.get('client.currentUser')
  let userForm = Object.keys(current).reduce((acc, key) => {
    if (shouldValidateFormForUser(key)) {
      let obj = {
        name: key,
        fields: []
      }
      if (currentUser && key === 'common') {
        obj.fields.push({
          key: '_id',
          value: currentUser._id,
          type: 'text',
          client: true
        })
      }

      Object.keys(current[key]).forEach(data => {
        let field = current[key][data]
        let value = {
          key: data,
          value: field.value,
          type: field.type || (Array.isArray(field.value) ? 'select' : 'text'),
          client: field.client || false
        }
        if (field.viesValidation) {
          value['viesValidation'] = true
          value['validateAgainst'] = field.validateAgainst
        }
        obj.fields.push(value)
      })
      acc.push(obj)
    }
    return acc
  }, [])

  services.Http.post('/api/user/save', userForm)
    .then(output.success)
    .catch(output.error)
}

saveUser.async = true
export default saveUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/saveUser.js